import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import Navbar from '#web-components/components/Navbar';
import Container from '#web-components/components/Container';
import LinkBack from '#web-components/components/LinkBack';
import HomeButton from '#web-components/components/Navbar/components/HomeButton';
import styles from './ErrorLayoutHeader.styles';

export interface ErrorLayoutHeaderProps {
  link: string;
  title?: string;
  navLinkComponent: React.ElementType;
  appTitle: string;
  homePath: string;
  hideNavigation?: boolean;
}

const useStyles = makeStyles(styles, { name: 'ErrorLayoutHeader' });

export default function ErrorLayoutHeader({
  link, title = '', navLinkComponent, appTitle, homePath, hideNavigation,
}:ErrorLayoutHeaderProps) {
  const classes = useStyles();
  return (
    <Container noPadding classes={{ root: classes.container }}>
      <Navbar disableBackground>
        <Box className={classes.box}>
          <Box>
            {!hideNavigation && <LinkBack to={link} title={title} component={navLinkComponent} />}
          </Box>
          <HomeButton direction="right" navLinkComponent={navLinkComponent} appTitle={appTitle} homePath={homePath} />
        </Box>
      </Navbar>
    </Container>

  );
}
